<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sUsername">Username </label>
                  <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sLevelId">VIP Level </label>
                  <b-form-select id="sVIPLevel" :plain="true" :options="levels" v-model="sLevelId" text-field="Name" value-field="Id">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00)</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime" :state="$v.sStartTime.$error?false:null" @blur.native="$v.sStartTime.$touch"></b-input>
                  <div v-if="$v.sStartTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sStartTime.required">Start Time is required</div>
                  </div>
                </b-col>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59)</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime" :state="$v.sEndTime.$error?false:null" @blur.native="$v.sEndTime.$touch"></b-input>
                  <div v-if="$v.sEndTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sEndTime.required">Start Time is required</div>
                  </div>
                </b-col>
                <b-col sm="4" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="searchLog" :disabled="$v.sStartTime.$invalid || $v.sEndTime.$invalid"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-papper-plane'></i> Log - VIP Level - Member</h3>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(Action)="data">
                <b-badge variant="success" v-if="data.item.Action === 1">Assign</b-badge>
                <b-badge variant="warning" v-else-if="data.item.Action === 2">Update</b-badge>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../../events.js'
  import moment from 'moment-timezone'

  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'viplevel-setting-log',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        levels: [],
        fields: [
          {key: 'Name', label: 'Level'},
          {key: 'Username', label: 'Username'},
          {key: 'Action', label: 'Action'},
          {key: 'Operator', label: 'Operator'},
          {key: 'UpdateTime', label: 'Log Time'}
        ],
        currentPage: 1,
        perPage: 30,
        operator: 0,
        sLevelId: '',
        sUsername: '',
        sStartTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD'),
        sEndTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD')
      }
    },
    watch: {
      currentPage: function () {
        this.searchRequest()
      }
    },
    validations: {
      sUsername: { minLength: minLength(1), maxLength: maxLength(50) },
      sLevelId: { required },
      sStartTime: { required },
      sEndTime: { required }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      searchLog () {
        let username = this.sUsername
        let levelId = this.sLevelId
        let startTime = this.sStartTime
        let endTime = this.sEndTime
        let queryStr = `?username=${username}&levelId=${levelId || ''}&startTime=${startTime}&endTime=${endTime}`
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/logs/member' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.record
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getVIPLevels () {
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/levels', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.levels = response.data.levels
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
      this.getVIPLevels()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/activityLog/payment/viplevel/VIPLevelMemberTable.vue